import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { RestSurveyTemplate } from '@shared/interfaces/survey-template';
import { RestTemplateAreaModel } from '@template/models/rest-template-model.interface';

@Injectable({
  providedIn: 'root',
})
export class SurveysService {
  constructor(private restApiService: RestapiService) {}

  getSurveyTemplates(): Observable<RestSurveyTemplate[]> {
    return this.restApiService.getData<RestSurveyTemplate[]>('AdminPanel/templatesList');
  }

  saveTemplate(id: number, template: string): Observable<RestSurveyTemplate[]> {
    return this.restApiService.update<RestSurveyTemplate[]>('AdminPanel/template', { id, template });
  }

  get(id: number, isGlobal: boolean): Observable<RestTemplateAreaModel> {
    return this.restApiService.getData<RestTemplateAreaModel>(
      `inspections/template/${isGlobal ? 'global/' : ''}survey/${id}`
    );
  }

  add(survey: RestTemplateAreaModel, isGlobal: boolean): Observable<number> {
    return this.restApiService.post<number>(`inspections/template/${isGlobal ? 'global/' : ''}survey/add`, survey);
  }

  update(survey: RestTemplateAreaModel, isGlobal: boolean): Observable<void> {
    return this.restApiService.post(`inspections/template/${isGlobal ? 'global/' : ''}survey/${survey.id}`, survey);
  }

  delete(id: number, isGlobal: boolean): Observable<void> {
    return this.restApiService.post<void>(`inspections/template/${isGlobal ? 'global/' : ''}survey/delete`, id);
  }
}
